import React from "react";

import { faVideo } from "@performyard/fontawesome/pro-solid-svg-icons";
import { Icon, Tooltip } from "@performyard/py-components";
import type { MeetingModelJson } from "@performyard/service-contracts";

import { getVideoConferencingProviderShortName } from "../../../../api/hooks/defs/meetings-integrations";

type MeetingVideoConferencingIconProps = {
	meeting: MeetingModelJson;
};

/**
 * Integrations-column video-conferencing icon. Grayed when the meeting has no video
 * conferencing; the camera takes on the connected (primary) color otherwise. Hover
 * reveals the connection status.
 */
const MeetingVideoConferencingIcon = ({ meeting }: MeetingVideoConferencingIconProps): React.ReactElement => {
	const provider = meeting.videoConference?.provider;
	const providerDisplayName = getVideoConferencingProviderShortName(provider);
	const tooltip = provider
		? providerDisplayName
			? `${providerDisplayName} Video Conferencing`
			: "Video Conferencing"
		: "No Video Conferencing";

	return (
		<Tooltip content={tooltip} placement="top">
			<div className="flex h-5 w-5 items-center justify-center">
				<Icon size={20} icon={faVideo} color={provider ? "primary-5" : "neutral-2"} />
			</div>
		</Tooltip>
	);
};

export default MeetingVideoConferencingIcon;
